var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAccountStatus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_account_status",
    d: "M281.9,806.722a3.84,3.84,0,1,1-3.688,3.836A3.764,3.764,0,0,1,281.9,806.722Zm5.995,12.464a2.772,2.772,0,1,1-2.619,2.768A2.7,2.7,0,0,1,287.9,819.186Zm-4.12,2.768a4.2,4.2,0,0,1,4.12-4.268,4.019,4.019,0,0,1,.454.047,6.688,6.688,0,0,0-3.144-2.723,1.06,1.06,0,0,0-.9.192,3.75,3.75,0,0,1-4.711-.019,1.061,1.061,0,0,0-.9-.2,6.7,6.7,0,0,0-4.169,5.78c-.1.9.387,3.1,7.389,3.13.857,0,1.615-.027,2.289-.083A4.346,4.346,0,0,1,283.778,821.954Z",
    transform: "translate(-274.517 -806.722)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAccountStatus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_account_status.cea72aeae0d76e07abcf1afa11e582bd.svg";